import React from "react";
import { BrandedAppPage } from "../../../components/admin/brands/BrandedAppPage";

export function AdminBrandedAppRoute() {
  return <BrandedAppPage />;
}
